<template>
  <div>
    <v-card
      v-if="downPaymentAccess.read"
      v-show="!loading"
      elevation="0"
      class="card-container px-8 py-4"
    >
      <div>
        <v-data-table
          class="denser"
          :search="searchString"
          :headers="headers"
          :items="downPayments"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading"
          loading-text="Loading... Please wait"
          no-data-text="All Down Payments will appear here."
          multi-sort
          :footer-props="
            !mobile
              ? { 'items-per-page-options': [12, 24, 48, 96, 200] }
              : { 'items-per-page-options': [5] }
          "
          dense
        >
          <template v-slot:item="{ item }">
            <tr
              v-long-press="(e) => onRowLongPress(item, e)"
              style="cursor: pointer"
              @contextmenu.prevent="showActions(item, $event)"
            >
              <td>
                <p class="caption">{{ item.refNo }}</p>
              </td>
              <td>
                <p class="caption">{{ item.paymentRefNo }}</p>
              </td>
              <td v-if="type !== Types.UNIT">
                <a class="caption" @click="redirectBed(item)">
                  {{ item.unitName }}
                </a>
              </td>
              <td v-if="type !== Types.UNIT && type !== Types.USER">
                <p class="caption">
                  {{ item.tenantName }}
                </p>
              </td>
              <td>
                <p class="caption">{{ item.formattedAmount }}</p>
              </td>
              <td>
                <p class="caption">
                  {{ item.parsedStatus }}
                </p>
              </td>
              <td>
                <p class="caption">
                  {{ item.startDate }}
                </p>
              </td>
              <td>
                <p class="caption">
                  {{ item.endDate }}
                </p>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-skeleton-loader
      v-show="loading"
      ref="skeleton"
      type="table"
      loading
      class="mx-auto"
    ></v-skeleton-loader>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <context-menu
      ref="contextMenu"
      no-items-message="No actions available"
    ></context-menu>
  </div>
</template>

<script>
import { parsePaymentStatus, PaymentStatus } from '../../config/payment'
import Hashids from 'hashids'
import ContextMenu from '../../components/menu/ContextMenu.vue'
import { blockClick } from '../../util/longPressDirective'

const hashids = new Hashids()

export default {
  components: {
    ContextMenu
  },
  props: [
    'searchString',
    'selectedStatuses',
    'selectedCategories',
    'statusItems',
    'selectedTags',
    'searchTrigger',
    'leaseId',
    'tenantId',
    'type'
  ],
  data() {
    return {
      PaymentStatus,
      parsePaymentStatus,
      loading: true,
      total: 0,
      limit: 0,
      options: {},
      snackbar: false,
      snackbarMessage: '',
      Types: {
        UNIT: 'unit',
        USER: 'user'
      }
    }
  },
  computed: {
    downPayments() {
      return this.$store.getters['downPayments/getDownPayments']
    },
    headers() {
      const headers = this.$store.getters['downPayments/getHeaders']

      switch (this.type) {
        case this.Types.UNIT:
          return headers.filter(
            (h) => !['unitName', 'tenantName'].includes(h.value)
          )
        case this.Types.USER:
          return headers.filter((h) => !['tenantName'].includes(h.value))
        default:
          return headers
      }
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    downPaymentAccess() {
      return this.$root.$roleAccess('down_payment').access
    },
    paidpaymentAccess() {
      return this.$root.$roleAccess('paidpayment').access
    },
    units() {
      return this.$store.getters['units/getUnitsFlat']
    }
  },
  watch: {
    options: {
      async handler() {
        await this.searchAction()
      }
    },
    searchTrigger: {
      async handler() {
        await this.searchAction()
      }
    }
  },
  methods: {
    async searchAction() {
      // if (!this.selectedStatuses.length > 0) {
      //   return
      // }
      this.loading = true
      const { limit, count } = await this.$store.dispatch(
        'downPayments/searchDownPaymentsAction',
        {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          status: this.selectedStatuses || [],
          categories: this.selectedCategories,
          tags: this.selectedTags,
          leaseId: this.leaseId,
          tenantId: this.tenantId
        }
      )

      this.loading = false
      this.limit = limit
      this.total = count
    },
    showPendingFeatureSnackMessage() {
      this.snackbarMessage = 'This feature is currently in development.'
      this.snackbar = true
    },
    async redirectBed(item) {
      try {
        const unit = this.units.find((u) => u.leaseId === item.leaseId)
        if (!unit)
          await this.$router.push(`/user/${item.tenant_details.username}`)
        if (unit.bedId)
          await this.$router.push(`/bed/${hashids.encode(unit.bedId)}`)
      } catch (err) {
        // eslint-disable-next-line
        console.log(err.message)
      }
    },
    reload() {
      this.searchAction()
    },
    async cancel(item) {
      const confirm = await this.$root.$confirm({
        title: 'Cancel Down Payment',
        message:
          'Are you sure you want to cancel the down payment? This will also cancel the associated pending payment.'
      })

      if (confirm) {
        this.$root.$setLoading(true)

        await this.$store.dispatch('downPayments/cancel', {
          _id: item._id
        })

        this.$root.$setLoading(false)
        await this.$root.$confirm({
          title: 'Cancel Down Payment',
          message: `The down payment has been cancelled.`,
          reconfirmOnly: true,
          confirmText: 'OK',
          options: {
            color: 'success'
          }
        })
        this.reload()
      }
    },
    getBaseActions(item) {
      return [
        {
          icon: 'mdi-close',
          color: 'error',
          title: 'Cancel Down Payment',
          action: () => this.cancel(item),
          message:
            'Cancel the down payment and revert the payment status to pending',
          show:
            item.status === PaymentStatus.PENDING &&
            this.downPaymentAccess.cancel,
          disabled: !this.downPaymentAccess.cancel
        }
      ]
    },
    showActions(item, event) {
      const actions = this.getBaseActions(item)

      this.$refs.contextMenu.open({
        actions,
        x: event.clientX,
        y: event.clientY
      })

      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    onRowLongPress(item, event) {
      this.showActions(item, event)
      blockClick(window)
    }
  }
}
</script>

<style scoped>
.v-card.card-container {
  border-radius: 12px !important;
}
</style>
